import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/icon/arrow.png'
import _imports_1 from '../../assets/img/hr.png'
import _imports_2 from '../../assets/img/mine/null.png'
import _imports_3 from '../../assets/img/icon/sy.png'
import _imports_4 from '../../assets/img/icon/book.png'
import _imports_5 from '../../assets/img/icon/qq.png'
import _imports_6 from '../../assets/img/icon/wx.png'


const _withScopeId = n => (_pushScopeId("data-v-215155f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-box" }
const _hoisted_2 = { class: "change_tab scroll-view" }
const _hoisted_3 = { class: "fix-tag" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "为上进发声", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/article?articleId=32" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content top" }, [
    /*#__PURE__*/_createElementVNode("p", null, "分享上进故事"),
    /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ])
], -1))
const _hoisted_8 = { class: "fix-tag-h5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/article?articleId=32" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top" }, "分享上进故事")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createTextVNode(" 上进帖子晒照 "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_11 = { class: "bx running-welfare-box" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = {
  key: 1,
  class: "null"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "null-img"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "暂无动态～", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "drag" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上进发声", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<li class=\"telphone\" data-v-215155f3><a href=\"/publicWelfare\" data-v-215155f3><img src=\"" + _imports_4 + "\" alt=\"\" data-v-215155f3><p data-v-215155f3>参与公益</p></a></li><li class=\"gzh\" data-v-215155f3><a href=\"/story\" data-v-215155f3><img src=\"" + _imports_3 + "\" alt=\"\" data-v-215155f3><p data-v-215155f3>上进故事</p></a></li><li class=\"last applets\" data-v-215155f3><img src=\"" + _imports_5 + "\" alt=\"\" data-v-215155f3><p data-v-215155f3>QQ</p></li><li class=\"last applets\" data-v-215155f3><img src=\"" + _imports_6 + "\" alt=\"\" data-v-215155f3><p data-v-215155f3>微信</p></li>", 4)

import { ref, onMounted } from 'vue';
import Banner from './components/banner.vue';
import VideoContent from './components/videoContent.vue';
// import Recommend from '@/components/Recommend.vue'
import Welfare from '@/components/Welfare.vue';
import StoryExhibition from '@/components/StoryExhibition.vue';
import Release from '@/components/release/index.vue';
import ArticleList from '@/components/ArticleList.vue';
import { ICircleInfoProps, PaginationProps } from '@/api/type';
import { MineFetch } from '@/api/request';
import { formatEmotions, formatWrap } from '@/lib';
import PostDetail from '@/components/PostDetail.vue';
import LoginToast from '@/components/loginToast.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const show = ref(false);
const type = ref('');
const contentFlag = ref('');
const showDrag = ref(false);
const showLogin = ref(false);
const loading = ref<boolean>(false);
const finished = ref<boolean>(true);
const list = ref<ICircleInfoProps[]>([]);
const pagination = ref<PaginationProps>({
  pageNum: 0,
  pageSize: 10
});
onMounted(() => {
  window.addEventListener('scroll', handleScroll, true);
  onLoad();
});
const showPost = (typeValue: string) => {
  if (window.localStorage.getItem('authToken')) {
    contentFlag.value = '#上进发声#';
    show.value = true;
    type.value = typeValue;
  } else {
    showLogin.value = true;
  }
};
const cancel = () => {
  show.value = false;
  console.log('22');
};
const scrollView = ({ name }) => {
  document.getElementsByClassName('scroll-view')[name].scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};

const onLoad = async() => {
  // 异步更新数据
  loading.value = true;

  pagination.value.pageNum += 1;
  const params = {
    userRoleType: '2',
    pageNum: pagination.value.pageNum,
    pageSize: pagination.value.pageSize
  };

  const res = await MineFetch.selRecCircleDynamics(params);
  const body = res.body;
  if (Array.isArray(body)) {
    body.forEach((item, index) => {
      // 超过100文字裁剪
      item.showText2 = false;
      if (typeof item.scText === 'string') {
        if (item.scText.length > 100) {
          item.scText2 = item.scText.substring(0, 100);
          item.showText2 = true;
        }
      }

      item.scText = formatWrap(item.scText);
      item.scText = formatEmotions(item.scText);

      item.scText2 = formatWrap(item.scText2);
      item.scText2 = formatEmotions(item.scText2);

      // 图片地址集合分割成数组
      if (item.scPicUrl) {
        item.picUrl = item.scPicUrl.split(',');
      } else {
        item.picUrl = [];
      }
      if (Array.isArray(item.praiseList)) {
        item.praiseList = item?.praiseList.slice(0, 4);
      }

      // 只有 scType === -3 extContent 才会有信息
      try {
        item.extContent = JSON.parse(item.extContent);
      } catch (e) {
        item.extContent = null;
      }
    });

    list.value = list.value.concat(body);
    // 加载状态结束
    loading.value = false;
    // 到底了
    if (body.length === 0 || body.length < pagination.value.pageSize) {
      finished.value = true;
    }
  }
  if (!body) {
    finished.value = true;
  }
};

const handleScroll = () => {
  const scrolltop =
    document.documentElement.scrollTop || document.body.scrollTop;
  scrolltop > 250 ? (showDrag.value = true) : (showDrag.value = false);
};
const toTop = () => {
  let top = document.documentElement.scrollTop || document.body.scrollTop;
  // 实现滚动效果
  const timeTop = setInterval(() => {
    document.body.scrollTop = document.documentElement.scrollTop = top -= 100;
    if (top <= 0) {
      clearInterval(timeTop);
    }
  }, 10);
};

return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_tabs, {
        active: _ctx.active,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
        onClickTab: scrollView
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tab, {
            name: "0",
            title: "上进发声"
          }),
          _createVNode(_component_van_tab, {
            name: "1",
            title: "参与公益"
          }),
          _createVNode(_component_van_tab, {
            name: "2",
            title: "上进故事"
          })
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "content",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showPost('1')))
      }, _hoisted_6),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (showPost('1')))
      }, "为上进发声"),
      _hoisted_9
    ]),
    _createVNode(VideoContent),
    _createVNode(ArticleList),
    _createVNode(Welfare, { class: "scroll-view" }),
    _createVNode(StoryExhibition, { class: "scroll-view" }),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (list.value.length > 0)
          ? (_openBlock(), _createBlock(_component_van_list, {
              key: 0,
              loading: loading.value,
              "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了",
              onLoad: onLoad,
              class: "list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "list-item"
                  }, [
                    _createVNode(PostDetail, { "post-info": item }, null, 8, ["post-info"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "finished"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_17, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showPost('1')))
        }, _hoisted_20),
        _hoisted_21,
        _createElementVNode("i", {
          class: "iconfont iconzhiding gotop",
          onClick: toTop
        })
      ])
    ], 512), [
      [_vShow, showDrag.value]
    ]),
    _createVNode(Release, {
      onCancel: _cache[5] || (_cache[5] = ($event: any) => {
        show.value = false;
        cancel;
      }),
      show: show.value,
      type: type.value,
      contentFlag: contentFlag.value
    }, null, 8, ["show", "type", "contentFlag"]),
    _createVNode(LoginToast, {
      showLogin: showLogin.value,
      "onUpdate:confirm": _cache[6] || (_cache[6] = ($event: any) => (showLogin.value = false))
    }, null, 8, ["showLogin"])
  ]))
}
}

})